/** Stored in `profiles.notification_preferences` (JSONB). */
export type NotificationPreferences = {
  weekly_digest: boolean
  overdue_tasks: boolean
  pending_documents: boolean
  itinerary_reminders: boolean
  /** Visas, consulates, etc. */
  appointment_reminders: boolean
  advance_days: 1 | 3 | 7
}

export const defaultNotificationPreferences = (): NotificationPreferences => ({
  weekly_digest: true,
  overdue_tasks: true,
  pending_documents: true,
  itinerary_reminders: true,
  appointment_reminders: true,
  advance_days: 3,
})

export type DateFormatOption = "DD/MM/YYYY" | "MM/DD/YYYY"

export type AppTheme = "light" | "dark" | "system"
